const MtrSearchOutline={
    "name": "mtr-search",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24"
        },
        "children": [
            {
                "tag": "g",
                "attrs": {
                    "fill": "none",
                    "fill-rule": "evenodd",
                    "stroke": "currentColor",
                    "stroke-width": "2"
                },
                "children": [
                    {
                        "tag": "circle",
                        "attrs": {
                            "cx": "10",
                            "cy": "10",
                            "r": "7"
                        }
                    },
                    {
                        "tag": "path",
                        "attrs": {
                            "stroke-linecap": "round",
                            "d": "M15 15l5 5"
                        }
                    }
                ]
            }
        ]
    }
};
export default MtrSearchOutline;